import { SessionStore } from './../state/session/session.store';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { AppConfigQuery } from '../state/app-config/app-config.query';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { environment } from '@environment';
import { SessionQuery } from '../state/session/session.query';

@Injectable({
    providedIn: 'root'
})
export class KeycloakGuard extends KeycloakAuthGuard implements CanActivate {
    constructor(
        protected router: Router,
        private appConfig: AppConfigQuery,
        private session: SessionQuery,
        private sessionStore: SessionStore,
        private kc: KeycloakService
    ) {
        super(router, kc);
    }

    async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        // legacy guard is used - skip guard
        if (!this.appConfig.get().useLatestKeycloakFlow) {
            return true;
        }

        if (!this.authenticated) {
            await this.kc.login({
                redirectUri: environment.production
                    ? `${window.location.origin}/${this.appConfig.get().keycloakRealm}${
                          state.url
                      }`
                    : `${window.location.origin}${state.url}`
            });
        }

        return this.authenticated;
    }
}
